import React, { useState } from 'react';
import { MagicLinkStore } from '@stores/MagicLinkStore';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const useLoginButtonController = () => {
  const authUrl = (import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000') + '/auth';

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [magicLinkLoading, setMagicLinkLoading] = useState(false);
  const [magicLinkError, setMagicLinkError] = useState('');

  const validateEmail = (value: string): boolean => {
    if (!value.trim()) {
      setEmailError('Email is required');
      return false;
    }
    if (!EMAIL_REGEX.test(value)) {
      setEmailError('Please enter a valid email address');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    if (emailError) {
      validateEmail(value);
    }
  };

  const handleSendMagicLink = async () => {
    if (!validateEmail(email)) return;

    setMagicLinkLoading(true);
    setMagicLinkError('');

    try {
      const store = new MagicLinkStore();
      await store.requestMagicLink(email);
      setMagicLinkSent(true);
    } catch {
      setMagicLinkError('Something went wrong. Please try again.');
    } finally {
      setMagicLinkLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSendMagicLink();
    }
  };

  const handleTryDifferentEmail = () => {
    setMagicLinkSent(false);
    setMagicLinkError('');
  };

  return {
    authUrl,
    email,
    emailError,
    magicLinkSent,
    magicLinkLoading,
    magicLinkError,
    handleEmailChange,
    handleSendMagicLink,
    handleKeyDown,
    handleTryDifferentEmail,
  };
};
